<div *ngIf="!ordenSelected" class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <!-- <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.nuevo}}
          </button>
        </div>
      </div>
    </div> -->
      <form [formGroup]="frmFiltros" class="form-group" novalidate>
        <div class="row">        
          <div class="form-group col-md-3">
            <app-lfsa-input [control]="frmFiltros.get('idOrden') | formControl" [id]="'idOrden'" [isReadOnly]="false"
              [label]="'Ticket Balanza'" [mostrarImg]="false" [placeholder]="'Ticket Balanza'" [rutaImagen]="" [type]="'number'"
              formControlName="idOrden">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-3">
            <app-lfsa-input [control]="frmFiltros.get('fechaIngreso') | formControl" [id]="'fechaIngreso'" [label]="'Fecha Iinicio'"
              [mostrarImg]="false" [placeholder]="'fechaIngreso'" [rutaImagen]="" [type]="'date'" formControlName="fechaIngreso">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-3">
            <app-lfsa-input [control]="frmFiltros.get('fechaFin') | formControl" [id]="'fechaFin'" [label]="'Fecha Fin'"
              [mostrarImg]="false" [placeholder]="'fechaFin'" [rutaImagen]="" [type]="'date'" formControlName="fechaFin">
            </app-lfsa-input>
          </div>
        </div>
        <div class="row mb-4">
          <div class="form-group col-md-3 d-flex align-items-center">
            <button (click)="buscarReporte()" class="btn btn-success btn-block">Buscar</button>
          </div>
        </div>
      </form>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
      [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
      [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
      [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->

<div *ngIf="ordenSelected" class="container-fluid">
  <form [formGroup]="agregarForm">
    <div class="row mb-2 p-3 border rounded">
      <div class="alert alert-secondary d-flex justify-content-between" role="alert">
        <div>Mantenimiento de Ordenes de Balanza</div>
        <div class="d-flex justify-content-end rounded bg-success px-3 text-white">ESTADO ORDEN BALANZA: {{ status }}
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <div class="col-lg-6 mb-2">
            <label for="">Orden de Balanza</label>
            <input class="form-control" formControlName="idOrden" name="idOrden" type="text">
            <div
              *ngIf="agregarForm.controls['idOrden'].invalid && (agregarForm.controls['idOrden'].dirty || agregarForm.controls['idOrden'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['idOrden'].errors">
                  El campo Fecha es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Fecha</label>
            <input class="form-control" formControlName="fecha" name="fecha" readonly type="text">
            <div
              *ngIf="agregarForm.controls['fecha'].invalid && (agregarForm.controls['fecha'].dirty || agregarForm.controls['fecha'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['fecha'].errors.required">
                  El campo Fecha es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <!-- <label for="">Tipo de Orden</label> -->
            <!-- <input type="text" class="form-control" formControlName="tipo"> -->
            <label for="">Tipo de Orden</label>
            <select (ngModelChange)="onChangeTipo($event)" class="form-control" formControlName="tipo">
              <option value="">-- Seleccione --</option>
              <option *ngFor="let data of cmbTipoOrden" [value]="data.id">{{ data.desca }}</option>
            </select>
            <div
              *ngIf="agregarForm.controls['tipo'].invalid && (agregarForm.controls['tipo'].dirty || agregarForm.controls['tipo'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['tipo'].errors">
                  El campo Fecha es requerido.
                </div>
              </small>
            </div>
          </div>
          <div *ngIf="showNumeroDeOrden" class="col-lg-6 mb-2">
            <label for="">Número de Orden</label>
            <input (keypress)="keyNumeric($event)" class="form-control" formControlName="numero" name="numero"
              type="text">
            <div class="text-muted">
              <small><small>Compra/Venta, Traslados, Maquila</small></small>
            </div>
            <div
              *ngIf="agregarForm.controls['numero'].invalid && (agregarForm.controls['numero'].dirty || agregarForm.controls['numero'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['numero'].errors">
                  El campo Número de Orden es requerido.
                </div>
              </small>
            </div>
          </div>
          <div *ngIf="this.showIngresoVacio" class="col-lg-6 mb-2 d-flex">
            <label class="mb-2" for="emptyIncome" style="margin-right: 15px;">
              Ingreso Vacio
            </label>
            <div class="form-check">
              <input (change)="validaciones()" class="form-check-input" formControlName="emptyIncome" id="emptyIncome"
                type="checkbox">
              <label class="form-check-label" for="emptyIncome">
                {{this.agregarForm.get('emptyIncome') && this.agregarForm.get('emptyIncome').value ? 'Si' : 'No'}}
              </label>
            </div>
          </div>
          <!-- <div class="col-lg-6 mb-2">
            <app-lfsa-input [addon]="false" [control]="agregarForm.get('freightNumber') | formControl"
              [id]="'freightNumber'" [isReadOnly]="true" [label]="'Número de Flete'" [mostrarImg]="false"
              [placeholder]="'Número de Flete'" [rutaImagen]="" [type]="'text'" formControlName="freightNumber">
            </app-lfsa-input>
          </div> -->


          <div class="col-lg-6 mb-2">
            <label for="">Factura</label>
            <input class="form-control" formControlName="factura" name="factura" type="text">
            <div
              *ngIf="agregarForm.controls['factura'].invalid && (agregarForm.controls['factura'].dirty || agregarForm.controls['factura'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['factura'].errors">
                  El campo Factura es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Guía</label>
            <input (keypress)="keyAlphaNumeric($event)" class="form-control" formControlName="guia" name="guia"
              type="text">
            <div
              *ngIf="agregarForm.controls['guia'].invalid && (agregarForm.controls['guia'].dirty || agregarForm.controls['guia'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['guia'].errors">
                  El campo Guía es requerido.
                </div>
              </small>
            </div>
          </div>
          <!-- <div class="col-lg-6 mb-2">
            <label for="">Proveedor</label>
            <input class="form-control" formControlName="proveedor" name="proveedor" type="text">
            <div
              *ngIf="agregarForm.controls['proveedor'].invalid && (agregarForm.controls['proveedor'].dirty || agregarForm.controls['proveedor'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['proveedor'].errors">
                  El campo Proveedor es requerido.
                </div>
              </small>
            </div>
          </div> -->
          <div class="col-6">
            <div class="mb-2">
              <label for="">Proveedor</label>
              <input (change)="onChangeProveedor($event);" (keyup)="onChangeProveedor($event);" autocomplete="off"
                class="form-control" formControlName="proveedor" name="proveedor" type="text">
            </div>
            <div *ngIf="proveedorInvalido" class="text-danger">
              <small>*Este proveedor es inválido</small>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Desc. Proveedor</label>
              <input autocomplete="off" class="form-control" formControlName="despro" name="despro" readonly
                type="text">
            </div>
          </div>

          <!-- <div class="col-lg-6 mb-2">
            <label for="">Cliente</label>
            <input class="form-control" formControlName="cliente" name="cliente" type="text">
            <div
              *ngIf="agregarForm.controls['cliente'].invalid && (agregarForm.controls['cliente'].dirty || agregarForm.controls['cliente'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['cliente'].errors">
                  El campo Cliente es requerido.
                </div>
              </small>
            </div>
          </div> -->
          <div class="col-6">
            <div class="mb-2">
              <label for="">Cliente</label>
              <input (change)="onChangeCliente($event);" (keyup)="onChangeCliente($event);" autocomplete="off"
                class="form-control" formControlName="cliente" name="cliente" type="text">
            </div>
            <div *ngIf="clienteInvalido" class="text-danger">
              <small>*Este cliente es inválido</small>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Desc. Cliente</label>
              <input autocomplete="off" class="form-control" formControlName="descli" name="descli" readonly
                type="text">
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Orden de Balanza Origen</label>
            <input class="form-control" formControlName="ordBalanzaOrigen" name="ordBalanzaOrigen" type="text">
            <div
              *ngIf="agregarForm.controls['ordBalanzaOrigen'].invalid && (agregarForm.controls['ordBalanzaOrigen'].dirty || agregarForm.controls['ordBalanzaOrigen'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['ordBalanzaOrigen'].errors">
                  El campo Orden de Balanza Origen es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Peso de O.Balanza Origen</label>
            <input class="form-control" formControlName="pesoBalanzaOrigen" name="pesoBalanzaOrigen" type="text">
            <div
              *ngIf="agregarForm.controls['pesoBalanzaOrigen'].invalid && (agregarForm.controls['pesoBalanzaOrigen'].dirty || agregarForm.controls['pesoBalanzaOrigen'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['pesoBalanzaOrigen'].errors">
                  El campo Peso de O.Balanza Origen es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Sellos</label>
            <input (keypress)="keyAlphaNumericCommaHyphen($event)" class="form-control" formControlName="sellos"
              name="sellos" type="text">
            <div
              *ngIf="agregarForm.controls['sellos'].invalid && (agregarForm.controls['sellos'].dirty || agregarForm.controls['sellos'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['sellos'].errors">
                  El campo Sellos es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Contenedor/Recurso</label>
            <input (keypress)="keyAlphaNumeric($event)" class="form-control" formControlName="contenedor"
              name="contenedor" type="text">
            <div
              *ngIf="agregarForm.controls['contenedor'].invalid && (agregarForm.controls['contenedor'].dirty || agregarForm.controls['contenedor'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['contenedor'].errors.required">
                  El campo Contenedor es requerido.
                </div>
                <div *ngIf="agregarForm.controls['fecha'].errors.maxLength">
                  *Máximo 12 caracteres
                </div>
              </small>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Material</label>
              <input (change)="onChangeMaterial($event)" (keyup)="onChangeMaterial($event);" autocomplete="off"
                class="form-control" formControlName="material" name="material" type="text">
              <div *ngIf="materialInvalido" class="text-danger">
                <small>*Este material es inválido</small>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Desc. Material</label>
              <input autocomplete="off" class="form-control" formControlName="desmat" name="desmat" readonly
                type="text">
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="row border">
          <div class="text-center border-bottom py-1">
            INFO DEL TICKET DE AUTORIZACIÓN DE TRANSPORTE
          </div>
          <div class="row py-3">
            <div class="col-lg-6 mb-2">
              <label for="">Digite Ticket Autorización</label>
              <input class="form-control" formControlName="ticketAuth" name="ticketAuth" type="text">
              <div
                *ngIf="agregarForm.controls['ticketAuth'].invalid && (agregarForm.controls['ticketAuth'].dirty || agregarForm.controls['ticketAuth'].touched)"
                class="text-danger">
                <small>
                  <div *ngIf="agregarForm.controls['ticketAuth'].errors">
                    El campo Ticket Autorización Transporte es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-6 mb-2">
              <!-- <button *ngIf="isCreate" (click)="buscarPlacaTransporte()" type="button"
                class="btn btn-success">Buscar</button> -->
              <label for="">Placa</label>
              <input class="form-control" formControlName="placa" name="placa" type="text">
              <div
                *ngIf="agregarForm.controls['placa'].invalid && (agregarForm.controls['placa'].dirty || agregarForm.controls['placa'].touched)"
                class="text-danger">
                <small>
                  <div *ngIf="agregarForm.controls['placa'].errors">
                    El campo Digite Placa es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="mb-2  ">
              <label for="">Datos Transportista</label>
            </div>
            <div class="col-lg-6 mb-2">
              <label for="">Chofer</label>
              <input class="form-control" formControlName="chofer" name="chofer" type="text">
              <div
                *ngIf="agregarForm.controls['chofer'].invalid && (agregarForm.controls['chofer'].dirty || agregarForm.controls['chofer'].touched)"
                class="text-danger">
                <small>
                  <div *ngIf="agregarForm.controls['chofer'].errors">
                    El campo Chofer es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <label for="">Cédula</label>
              <input class="form-control" formControlName="cedChofer" name="cedChofer" type="text">
              <div
                *ngIf="agregarForm.controls['cedChofer'].invalid && (agregarForm.controls['cedChofer'].dirty || agregarForm.controls['cedChofer'].touched)"
                class="text-danger">
                <small>
                  <div *ngIf="agregarForm.controls['cedChofer'].errors">
                    El campo Cédula es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-2 mb-2 d-flex justify-content-start align-items-end">
              <button (click)="openModal()" [disabled]="!placaResponse?.codigo" class="btn btn-info text-white"
                type="button">Ver <i aria-hidden="true" class="fa fa-eye"></i></button>
            </div>
          </div>
        </div>
        <div class="row border mt-3 py-3">
          <div class="col-lg-2 mb-2 d-flex align-items-end mb-3">
            ORIGEN
          </div>
          <div class="col-lg-5 mb-2">
            <label for="">Centro</label>
            <select class="form-control" formControlName="centroOri" name="centroOri">
              <option value="">-- seleccione --</option>
              <option *ngFor="let cen of centrosCmb" [value]="cen.idCentro">{{cen.idCentro}} - {{cen.nombreCentro}}</option>
            </select>
            <div
              *ngIf="agregarForm.controls['centroOri'].invalid && (agregarForm.controls['centroOri'].dirty || agregarForm.controls['centroOri'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['centroOri'].errors">
                  El campo Centro es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-5 mb-2">
            <label for="">Almacén</label>
            <select class="form-control" formControlName="almanceOri" name="almanceOri">
              <option value="">-- seleccione --</option>
              <option *ngFor="let alm of almacenesCmb" [value]="alm.idAlmacen">{{alm.idAlmacen}} - {{alm.dscaAlmacen}}</option>
            </select>
            <div
              *ngIf="agregarForm.controls['almanceOri'].invalid && (agregarForm.controls['almanceOri'].dirty || agregarForm.controls['almanceOri'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['almanceOri'].errors">
                  El campo Almacén es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-2 mb-2 d-flex align-items-end mb-3">
            DESTINO
          </div>
          <div class="col-lg-5 mb-2">
            <label for="">Centro D</label>
            <select class="form-control" formControlName="centroDest" name="centroDest">
              <option value="">-- seleccione --</option>
              <option *ngFor="let cen of centrosCmb" [value]="cen.idCentro">{{cen.idCentro}} - {{cen.nombreCentro}}</option>
            </select>
            <div
              *ngIf="agregarForm.controls['centroDest'].invalid && (agregarForm.controls['centroDest'].dirty || agregarForm.controls['centroDest'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['centroDest'].errors">
                  El campo Centro es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-5 mb-2">
            <label for="">Almacén</label>
            <select class="form-control" formControlName="almaceDest" name="almaceDest">
              <option value="">-- seleccione --</option>
              <option *ngFor="let alm of almacenesCmb" [value]="alm.idAlmacen">{{alm.idAlmacen}} - {{alm.dscaAlmacen}}</option>
            </select>
            <div
              *ngIf="agregarForm.controls['almaceDest'].invalid && (agregarForm.controls['almaceDest'].dirty || agregarForm.controls['almaceDest'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['almaceDest'].errors">
                  El campo Almacén es requerido.
                </div>
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-secondary mt-3" role="alert">
        Datos recibidos del proveedor / Datos Flete
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="border-bottom mb-2">DATOS RECIBIDOS</div>
          <div class="row">
            <div class="col-lg-3 mb-2">
              <label>Origen</label>
              <select class="form-control" formControlName="origOrd" name="tipo">
                <option value="">-- Seleccione --</option>
                <option *ngFor="let origen of origenesExtractoras" [value]="origen.id">{{origen.id}} - {{origen.descripcion}}</option>
              </select>
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.get('origOrd')?.hasError('required')">
                    El campo Origen es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-3 mb-2">
              <label for="">Peso bruto</label>
              <input (keypress)="keyDecimals($event)" class="form-control" formControlName="pesoBruto" name="pesoBruto"
                type="text">
              <div
                *ngIf="agregarForm.controls['pesoBruto'].invalid && (agregarForm.controls['pesoBruto'].dirty || agregarForm.controls['pesoBruto'].touched)"
                class="text-danger">
                <small>
                  <div *ngIf="agregarForm.controls['pesoBruto'].errors">
                    El campo Peso bruto es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-3 mb-2">
              <label for="">Peso neto</label>
              <input (keypress)="keyDecimals($event)" class="form-control" formControlName="pesoNeto" name="pesoNeto"
                type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="agregarForm.controls['pesoNeto']?.hasError('required')">
                    El campo Peso neto es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-3 mb-2">
              <label for="">Tara</label>
              <input (keypress)="keyDecimals($event)" class="form-control" formControlName="tara" name="tara"
                type="text">
              <div
                *ngIf="agregarForm.controls['tara'].invalid && (agregarForm.controls['tara'].dirty || agregarForm.controls['tara'].touched)"
                class="text-danger">
                <small>
                  <div *ngIf="agregarForm.controls['tara'].errors">
                    El campo Tara es requerido.
                  </div>
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="border-bottom mb-2">CALIDAD RECIBIDA</div>
          <div class="row">
            <div class="col-lg-4 mb-2">
              <label for="">Acidez</label>
              <input (keypress)="keyDecimals($event)" class="form-control" formControlName="acidez" name="acidez"
                type="text">
              <div
                *ngIf="agregarForm.controls['acidez'].invalid && (agregarForm.controls['acidez'].dirty || agregarForm.controls['acidez'].touched)"
                class="text-danger">
                <small>
                  <div *ngIf="agregarForm.controls['acidez'].errors">
                    El campo Acidez es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <label for="">Humedad</label>
              <input (keypress)="keyDecimals($event)" class="form-control" formControlName="humedad" name="humedad"
                type="text">
              <div
                *ngIf="agregarForm.controls['humedad'].invalid && (agregarForm.controls['humedad'].dirty || agregarForm.controls['humedad'].touched)"
                class="text-danger">
                <small>
                  <div *ngIf="agregarForm.controls['humedad'].errors">
                    El campo Humedad es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <label for="">Impureza</label>
              <input (keypress)="keyDecimals($event)" class="form-control" formControlName="impureza" name="impureza"
                type="text">
              <div
                *ngIf="agregarForm.controls['impureza'].invalid && (agregarForm.controls['impureza'].dirty || agregarForm.controls['impureza'].touched)"
                class="text-danger">
                <small>
                  <div *ngIf="agregarForm.controls['impureza'].errors">
                    El campo Impureza es requerido.
                  </div>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-secondary mt-3 d-flex" role="alert">
        <div class="w-50 d-flex align-items-center">
          <span> Orden de Compra SAP</span>
        </div>
        <div class="w-50 d-flex justify-content-end align-items-center">
          <!-- <button (click)="capturaDePesoSalida()" class="btn btn-info" style="color: white" type="button">Reenviar
          </button> -->
        </div>
      </div>
      <div class="row border m-0">
        <div class="col-lg-2">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('ocStatus') | formControl" [id]="'ocStatus'"
            [isReadOnly]="true" [label]="'ESTADO'" [mostrarImg]="false" [placeholder]="'ESTADO'" [rutaImagen]=""
            [type]="'text'" formControlName="ocStatus">
          </app-lfsa-input>
        </div>
        <div class="col-lg-2">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('solpedNumber') | formControl"
            [id]="'solpedNumber'" [isReadOnly]="true" [label]="'N# SOLPED'" [mostrarImg]="false"
            [placeholder]="'N# SOLPED'" [rutaImagen]="" [type]="'text'" formControlName="solpedNumber">
          </app-lfsa-input>
        </div>
        <div class="col-lg-2">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('ocNumber') | formControl" [id]="'ocNumber'"
            [isReadOnly]="true" [label]="'N# OC'" [mostrarImg]="false" [placeholder]="'N# OC'" [rutaImagen]=""
            [type]="'text'" formControlName="ocNumber">
          </app-lfsa-input>
        </div>
        <div class="col-lg-3">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('creationDateOC') | formControl"
            [id]="'creationDateOC'" [isReadOnly]="true" [label]="'FECHA CREACION'" [mostrarImg]="false"
            [placeholder]="'FECHA CREACION'" [rutaImagen]="" [type]="'text'" formControlName="creationDateOC">
          </app-lfsa-input>
        </div>
        <div class="col-lg-3">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('updateDateOC') | formControl"
            [id]="'updateDateOC'" [isReadOnly]="true" [label]="'FECHA ACTUALIZACION'" [mostrarImg]="false"
            [placeholder]="'FECHA ACTUALIZACION'" [rutaImagen]="" [type]="'text'" formControlName="updateDateOC">
          </app-lfsa-input>
        </div>
      </div>


      <div class="alert alert-secondary mt-3" role="alert">
        Información del lote de inspección
      </div>
      <div class="d-flex flex-wrap justify-content-between">
        <div class="">
          <label for="">Número Lote</label>
          <input class="form-control" formControlName="loteInsp" name="loteInsp" type="text">
          <div class="text-danger">
            <small>
              <div *ngIf="agregarForm.get('loteInsp')?.hasError('required')">
                El campo Número Lote es requerido.
              </div>
            </small>
          </div>
        </div>
        <div class="">
          <label for="">GRADO API</label>
          <input (keypress)="keyDecimals($event)" class="form-control" formControlName="gradoApi" name="gradoApi"
            type="text">
          <div class="text-danger">
            <small>
              <div *ngIf="agregarForm.get('gradoApi')?.hasError('required')">
                El campo GRADO API es requerido.
              </div>
            </small>
          </div>
        </div>

        <div class="">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('inspectionLotAcidity') | formControl"
            [id]="'inspectionLotAcidity'" [isReadOnly]="true" [label]="'Acidez'" [mostrarImg]="false"
            [placeholder]="'Acidez'" [rutaImagen]="" [type]="'text'" formControlName="inspectionLotAcidity">
          </app-lfsa-input>
        </div>
        <div class="">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('inspectionLotMoisture') | formControl"
            [id]="'inspectionLotMoisture'" [isReadOnly]="true" [label]="'Humedad'" [mostrarImg]="false"
            [placeholder]="'Humedad'" [rutaImagen]="" [type]="'text'" formControlName="inspectionLotMoisture">
          </app-lfsa-input>
        </div>
        <div class="">
          <app-lfsa-input [addon]="false" [control]="agregarForm.get('inspectionLotImpurity') | formControl"
            [id]="'inspectionLotImpurity'" [isReadOnly]="true" [label]="'Impureza'" [mostrarImg]="false"
            [placeholder]="'Impureza'" [rutaImagen]="" [type]="'text'" formControlName="inspectionLotImpurity">
          </app-lfsa-input>
        </div>

        <div class="">
          <label for="">Decisión de Empleo</label>
          <input class="form-control" formControlName="decisionEmpleo" name="decisionEmpleo" type="text">
          <div class="text-danger">
            <small>
              <div *ngIf="agregarForm.get('decisionEmpleo')?.hasError('required')">
                El campo Decisión de Empleo es requerido.
              </div>
            </small>
          </div>
        </div>
        <!-- <div class="">
          <label for="">Estatus de calidad</label>
          <input class="form-control" formControlName="calidad" name="calidad" type="text">
          <div class="text-danger">
            <small>
              <div *ngIf="agregarForm.get('calidad')?.hasError('required')">
                El campo Estatus de calidad es requerido.
              </div>
            </small>
          </div>
        </div> -->
      </div>


      <div class="alert alert-secondary mt-3" role="alert">
        Captura de pesos Entrada/Salida
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="d-flex justify-content-between">
            <div>CAPTURA DE PESOS ENTRADA</div>
            <div>
              <i (click)="imprimirCapturaEntrada()" *ngIf="!imprimirCapturaEntradaLoading" aria-hidden="true"
                class="fa fa-print text-muted" style="cursor: pointer;"></i>
              <i *ngIf="imprimirCapturaEntradaLoading" class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-center">
            <div class="row border py-3">
              <div class="col-lg-3">
                <div class="">
                  <label for="">Fecha entrada</label>
                  <input class="form-control" formControlName="fechIn" name="fechIn" type="text">
                  <div
                    *ngIf="agregarForm.controls['fechIn'].invalid && (agregarForm.controls['fechIn'].dirty || agregarForm.controls['fechIn'].touched)"
                    class="text-danger">
                    <small>
                      <div *ngIf="agregarForm.controls['fechIn'].errors">
                        El campo Fecha entrada de calidad es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="">
                  <label for="">Hora entrada</label>
                  <input class="form-control" formControlName="horaEntrada" name="horaEntrada" type="time">
                  <div
                    *ngIf="agregarForm.controls['horaEntrada'].invalid && (agregarForm.controls['horaEntrada'].dirty || agregarForm.controls['horaEntrada'].touched)"
                    class="text-danger">
                    <small>
                      <div *ngIf="agregarForm.controls['horaEntrada'].errors">
                        El campo Hora entrada es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="">
                  <label for="">Peso entrada</label>
                  <input (keypress)="keyNumeric($event)" class="form-control" formControlName="pesoIn" name="pesoIn"
                    type="text">
                  <div
                    *ngIf="agregarForm.controls['pesoIn'].invalid && (agregarForm.controls['pesoIn'].dirty || agregarForm.controls['pesoIn'].touched)"
                    class="text-danger">
                    <small>
                      <div *ngIf="agregarForm.controls['pesoIn'].errors">
                        El campo Peso entrada es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 d-flex justify-content-center align-items-end">
                <button (click)="capturaDePesoEntrada()" *ngIf="isCreate" [disabled]="capturaPesoInAction"
                  class="btn btn-success" type="button">Capturar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 px-3">
          <div class="d-flex justify-content-between">
            <div>CAPTURA DE PESOS SALIDA</div>
            <div>
              <i (click)="imprimirCapturaSalida()" *ngIf="!imprimirCapturaSalidaLoading" aria-hidden="true"
                class="fa fa-print text-muted" style="cursor: pointer;"></i>
              <i *ngIf="imprimirCapturaSalidaLoading" class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-center">
            <div class="row border py-3">
              <div class="col-lg-3">
                <div class="">
                  <label for="">Fecha salida</label>
                  <input class="form-control" formControlName="fechOut" name="fechOut" type="text">
                  <div
                    *ngIf="agregarForm.controls['fechOut'].invalid && (agregarForm.controls['fechOut'].dirty || agregarForm.controls['fechOut'].touched)"
                    class="text-danger">
                    <small>
                      <div *ngIf="agregarForm.controls['fechOut'].errors">
                        El campo Fecha salida es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="">
                  <label for="">Hora salida</label>
                  <input class="form-control" formControlName="horaSalida" name="horaSalida" type="time">
                  <div
                    *ngIf="agregarForm.controls['horaSalida'].invalid && (agregarForm.controls['horaSalida'].dirty || agregarForm.controls['horaSalida'].touched)"
                    class="text-danger">
                    <small>
                      <div *ngIf="agregarForm.controls['horaSalida'].errors">
                        El campo Hora salida es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="">
                  <label for="">Peso salida</label>
                  <input (keypress)="keyDecimals($event)" class="form-control" formControlName="pesoOut" name="pesoOut"
                    type="text">
                  <div
                    *ngIf="agregarForm.controls['pesoOut'].invalid && (agregarForm.controls['pesoOut'].dirty || agregarForm.controls['pesoOut'].touched)"
                    class="text-danger">
                    <small>
                      <div *ngIf="agregarForm.controls['pesoOut'].errors">
                        El campo Peso salida es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 d-flex justify-content-center align-items-end">
                <button (click)="capturaDePesoSalida()" *ngIf="!isCreate" class="btn btn-success" type="button">Capturar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="alert alert-secondary mt-3" role="alert">
        Información de la Balanza
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="d-flex justify-content-center align-items-center">
            <div class="">
              <label for="">SU BALANZA</label>
              <input class="form-control" formControlName="ordenFijaDescription" name="ordenFijaDescription" readonly
                type="text">
              <div
                *ngIf="agregarForm.controls['ordenFijaDescription'].invalid && (agregarForm.controls['ordenFijaDescription'].dirty || agregarForm.controls['ordenFijaDescription'].touched)"
                class="text-danger">
                <small>
                  <div *ngIf="agregarForm.controls['ordenFijaDescription'].errors">
                    El campo SU BALANZA es requerido.
                  </div>
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="d-flex justify-content-center align-items-center">
            <div class="">
              <label for="">USUARIO ACTUAL</label>
              <input class="form-control" formControlName="usuario" name="usuario" readonly type="text">
              <div
                *ngIf="agregarForm.controls['usuario'].invalid && (agregarForm.controls['usuario'].dirty || agregarForm.controls['usuario'].touched)"
                class="text-danger">
                <small>
                  <div *ngIf="agregarForm.controls['usuario'].errors">
                    El campo USUARIO ACTUAL es requerido.
                  </div>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <button (click)="regresar()" *ngIf="!isCreate" class="btn btn-success">Regresar</button>
    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [class.d-none]="!isCreate"
      [formularioValido]="agregarForm.invalid" [loading]="loading" [textBoton]="'Guardar'" class="row">
    </app-lfsa-botones-formulario>
  </form>
</div>
<!-- END MODAL -->


<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-md'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [idOpen]="'Modal2'"
  [innTemplate]="abrirModalAgregarGarita" [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModalAgregarGarita>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-6">
        <label for="codigo">Código</label>
        <input [value]="placaResponse?.codigo" class="form-control" disabled id="codigo" name="codigo" type="text">
      </div>
      <div class="col-lg-6">
        <label for="placa">Placa</label>
        <input [value]="placaResponse?.placa" class="form-control" disabled id="placa" name="placa" type="text">
      </div>
      <div class="col-lg-6">
        <label for="cedula">Cedula</label>
        <input [value]="this.agregarForm.get('cedChofer').value" class="form-control" disabled id="cedula" name="cedula" type="text">
      </div>
      <div class="col-lg-6">
        <label for="marca">Marca</label>
        <input [value]="placaResponse?.marca" class="form-control" disabled id="marca" name="marca" type="text">
      </div>
      <div class="col-lg-12">
        <label for="chofer">Chofer</label>
        <input [value]="this.agregarForm.get('chofer').value" class="form-control" disabled id="chofer" name="chofer" type="text">
      </div>
    </div>
  </div>
</ng-template>
<!-- END MODAL -->

<app-lfsa-modal [classModal]="'modal-md'" [idButton]="'fillOne'" [idOpen]="'Modal'" [idClose]="'cerrarModalPeso'"
  [innTemplate]="abrirModalPeso" [titulo]="'PESO CAPTURADO'"></app-lfsa-modal>
<ng-template #abrirModalPeso>
  <div class="container-fluid">
    <div class="row">
      <form [formGroup]="fomularioPeso" novalidate class="form-group">
        <div [class]="'col-md-12'">
          <!--[isReadOnly]="true"-->
          <app-lfsa-input  [claseLabel]="'letrasDanger'" (change)="onChangePeso();" (keyup)="onChangePeso();"  [mostrarImg]="false" [rutaImagen]="" [control]="fomularioPeso.get('pesoBalanza')"
                  [placeholder]="'0.0'" formControlName="pesoBalanza" [label]="'PESO'" [type]="'number'" [id]="'pesoBalanza'">
          </app-lfsa-input>
        </div>
        <div class="row">
          <div [class]="'col-lg-6'">
            <div *ngIf="!loading">
              <label>&nbsp;</label>
              <button  class="btn btn-danger btn-block"  (click)="cerrarModalPeso()">Cerrar</button>
            </div>
          </div>
          <div [class]="'col-lg-6'">
            <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
            <div *ngIf="!loading">
              <label>&nbsp;</label>
              <button  class="btn btn-success btn-block" [disabled]="agregarForm.invalid" (click)="guardarEditar()">Aceptar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
